import { render, staticRenderFns } from "./ProjectNewModal.vue?vue&type=template&id=d480440a&"
import script from "./ProjectNewModal.vue?vue&type=script&lang=js&"
export * from "./ProjectNewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports